import React, { useEffect, useRef, useState } from "react";
import { API } from "../../constant";
import { fetchWithAuth } from "../../api/fetchWithAuth";
import {
	Content,
	Row,
	SimpleTable,
	Col,
	Box,
	Inputs,
	Button,
} from "adminlte-2-react";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./UnitForm.css";

const { Text, Select2, Checkbox } = Inputs;

const TEMPARATURE = "TEMPARATURE";
const PBR = "PBR";

// Типы элементов (только для isDiagram = true)
const ELEMENT_TYPES = {
	ROLLING_TROLLEY: "ROLLING_TROLLEY",
	GROUNDING_KNIFE: "GROUNDING_KNIFE",
	INDICATOR_VALUE: "INDICATOR_VALUE",
};

const elementTypeOptions = [
	{
		text: "выкатная тележка выключателя",
		value: ELEMENT_TYPES.ROLLING_TROLLEY,
	},
	{
		text: "заземляющий нож",
		value: ELEMENT_TYPES.GROUNDING_KNIFE,
	},
	{
		text: "значение показателя",
		value: ELEMENT_TYPES.INDICATOR_VALUE,
	},
];

const getKindLabel = (kind) => {
	const option = elementTypeOptions.find((opt) => opt.value === kind);
	return option ? option.text : "значение показателя";
};

const dataProvisionType = [
	{
		text: "Температура",
		value: TEMPARATURE,
	},
	{
		text: "Выроботка ПБР",
		value: PBR,
	},
	{
		text: "Прочие",
		value: "NOT_IMPLEMENTED",
	},
];

const columns = [
	{ title: "Протокол", data: "protocolName" },
	{ title: "Время прихода сигнала", data: "createdAt" },
	{ title: "Блок/Схема", data: "unitsName" },
	{ title: "Имя", data: "name" },
	{ title: "Тип сигнала", data: "signalType" },
	{ title: "Код качества", data: "quality" },
];

const UnitForm = (props) => {
	const { updateMenu, isDiagram } = props;
	const wrapperRef = useRef(null);
	const [currentStep, setCurrentStep] = useState(1);
	const unitId = props.match.params.id;
	const [isEditing, setIsEditing] = useState(false);
	const [formData, setFormData] = useState({
		onlyTeleMeasurement: false,
		protocolType: "",
	});
	const [dataTable, setDataTable] = useState([]);
	const [redirectId, setRedirectId] = useState("");
	const [dataCandidateTable, setDataCandidateTable] = useState([]);

	const [idModbus, setIdModbus] = useState();
	const [name, setName] = useState();
	const [fuxaView, setFuxaView] = useState();
	const [fuxaViews, setFuxaViews] = useState([]);
	const [fuxaViewsError, setFuxaViewsError] = useState(null);
	const [protocolTypes, setProtocolTypes] = useState([]);

	const [hasTemperature, setHasTemperature] = useState(false);
	const [hasPbr, setHasPbr] = useState(false);
	const [errors, setErrors] = useState({});

	useEffect(() => {
		checkIfDataProvisionExists();
	}, [dataCandidateTable]);

	// Определить колонки для таблицы добавленных элементов
	const getCandidateColumns = () => {
		const baseColumns = [
			{ title: "", data: "protocolName" },
			{ title: "", data: "createdAt" },
			{ title: "", data: "name" },
		];

		// Добавить колонку типа элемента только для isDiagram
		if (isDiagram) {
			baseColumns.push({
				title: "",
				data: "kind",
				render: (kind, row) => (
					<>
						<Select2
							placeholder="Тип элемента"
							allowClear
							size="sm"
							sm={12}
							labelSm={0}
							name="kind"
							options={elementTypeOptions}
							value={row.kind || ELEMENT_TYPES.INDICATOR_VALUE}
							onChange={(e) => handleElementTypeChange(row.key, e.target.value)}
						/>
					</>
				),
			});
		}

		// Добавить колонку представления данных только если НЕ isDiagram
		if (!isDiagram) {
			baseColumns.push({
				title: "",
				data: "dataProvision",
				render: (dataProvision) => (
					<>
						<Select2
							placeholder="Представление данных"
							allowClear
							size="sm"
							sm={10}
							disabled={dataProvision.type !== "measurement"}
							labelSm={0}
							name="dataProvision"
							options={dataProvisionType}
							value={dataProvision.value}
							onChange={(e) =>
								handleDataProvisionChange(dataProvision.key, e.target.value)
							}
						/>
					</>
				),
			});
		}

		// Добавить колонки типа сигнала и качества
		baseColumns.push(
			{ title: "", data: "signalType" },
			{ title: "", data: "quality" },
		);

		return baseColumns;
	};

	const candidateColumns = getCandidateColumns();

	const handleElementTypeChange = (key, newKind) => {
		setDataCandidateTable((prevRows) =>
			prevRows.map((row) => {
				if (row.key === key) {
					row.kind = newKind;
					row.kindLabel = getKindLabel(newKind);
				}
				return row;
			}),
		);
	};

	const handleDataProvisionChange = (key, newDataProvision) => {
		setDataCandidateTable((prevRows) =>
			prevRows.map((row) => {
				if (row.dataProvision.value === newDataProvision && row.key !== key) {
					row.dataProvision.value = "NOT_IMPLEMENTED";
				} else if (row.key === key) {
					row.dataProvision.value = newDataProvision;
				}
				return row;
			}),
		);
	};

	const checkIfDataProvisionExists = () => {
		// Пропустить проверку если isDiagram (для диаграмм не нужна проверка)
		if (isDiagram) return;

		const temparatureExists = dataCandidateTable.some(
			(row) =>
				row.type === "measurement" && row.dataProvision.value === TEMPARATURE,
		);
		const pbrExists = dataCandidateTable.some(
			(row) => row.type === "measurement" && row.dataProvision.value === PBR,
		);

		setHasTemperature(temparatureExists);
		setHasPbr(pbrExists);

		const newErrors = {};
		if (!temparatureExists) {
			newErrors.temperature =
				"Представление данных температура является обязательной для телеизмерений";
		}
		if (!pbrExists) {
			newErrors.PBR =
				"Представление данных выроботка ПБР является обязательной для телеизмерений";
		}
		setErrors(newErrors);
	};

	const handleNext = () => {
		setCurrentStep((prev) => prev + 1);
	};

	const handleBack = () => {
		setCurrentStep((prev) => prev - 1);
	};

	const handleChangeIdModbus = (event) => {
		const { name, value } = event.target;
		setIdModbus(value);
	};

	const handleChangeName = (event) => {
		const { name, value } = event.target;
		setName(value);
	};

	const handleChangeFuxaView = (event) => {
		setFuxaView(event.target.value);
	};

	const fetchProtocolTypes = async () => {
		try {
			const response = await fetchWithAuth(`${API}/protocol-types`);
			const data = await response.json();
			const protocolTypes = (data?.data ?? []).map((item) => ({
				text: item.attributes.title,
				value: item.id,
			}));
			setProtocolTypes(protocolTypes);
		} catch (error) {
			console.error(error);
		}
	};

	const fetchTele = async () => {
		const teleSignals = await fetchTeleSignals();
		const teleMeasurements = await fetchTeleMeasurements();

		const table = [...(teleSignals ?? []), ...(teleMeasurements ?? [])];
		table.sort((a, b) => Date.parse(a.createdAt) - Date.parse(b.createdAt));

		if (table.length > 0) {
			setDataTable(table);
		} else {
			setDataTable([{ protocolName: "данные отсутствуют" }]);
		}
	};

	const fetchTeleMeasurements = async () => {
		try {
			// Для isDiagram используем новую populate структуру
			const populateQuery = isDiagram
				? `?populate[0]=signalType,protocol&populate[1]=protocol.protocolType`
				: `?populate[0]=units,signalType,protocol&populate[1]=protocol.protocolType`;

			const response = await fetchWithAuth(
				`${API}/tele-measurements${populateQuery}`,
			);
			const data = await response.json();
			if (typeof data !== "undefined" && data.data.length > 0) {
				const ids = data.data.map((item) => item.id).join(",");
				const qualityMap = await getQuality(ids);

				const teleMeasurementsData = data.data.map((item) => ({
					id: item.id,
					key: `${item.id}_measurement`,
					name: item.attributes.name,
					createdAt: moment(item.attributes.createdAt).format(
						"YYYY-MM-DD HH:mm:ss",
					),
					unitsName: isDiagram
						? ""
						: [
								...item.attributes.units.data
									.filter((unit) => !unit.attributes.isDiagram)
									.map((unit) => `Блок_${unit.attributes.name}`),
								...item.attributes.units.data
									.filter((unit) => unit.attributes.isDiagram)
									.map((unit) => `Схема_${unit.attributes.name}`),
							]
								.filter((unit) => unit)
								.join(),
					signalType: item.attributes?.signalType?.data?.attributes?.title,
					protocolName: item.attributes?.protocol?.data?.attributes?.title,
					type: "measurement",
					protocolTypeId:
						item.attributes?.protocol?.data?.attributes?.protocolType?.data?.id,
					// Для isDiagram добавить поле kind
					kind: isDiagram ? ELEMENT_TYPES.INDICATOR_VALUE : undefined,
					kindLabel: isDiagram
						? getKindLabel(ELEMENT_TYPES.INDICATOR_VALUE)
						: undefined,
					quality: qualityMap.get(item.id) ?? null,
					dataProvision: { key: `${item.id}_measurement`, type: "measurement" },
				}));
				return teleMeasurementsData;
			}
		} catch (error) {
			console.error(error);
		}
	};

	const getQuality = async (ids) => {
		const qualityResponse = await fetchWithAuth(
			`${API}/tele-quality?ids=${ids}`,
		);
		const qualityData = await qualityResponse.json();
		const qualityMap = new Map();
		qualityData.map((obj) => {
			qualityMap.set(obj.param_id, obj.quality);
		});
		return qualityMap;
	};

	const fetchTeleSignals = async () => {
		try {
			// Для isDiagram используем новую populate структуру
			const populateQuery = isDiagram
				? `?populate[0]=signalType,protocol&populate[1]=protocol.protocolType`
				: `?populate[0]=units,signalType,protocol&populate[1]=protocol.protocolType`;

			const response = await fetchWithAuth(
				`${API}/tele-signals${populateQuery}`,
			);
			const data = await response.json();
			if (typeof data !== "undefined" && data.data.length > 0) {
				const ids = data.data.map((item) => item.id).join(",");
				const qualityMap = await getQuality(ids);

				const teleSignalsData = data.data.map((item) => ({
					id: item.id,
					key: `${item.id}_signal`,
					name: item.attributes.name,
					createdAt: moment(item.attributes.createdAt).format(
						"YYYY-MM-DD HH:mm:ss",
					),
					unitsName: isDiagram
						? ""
						: [
								...item.attributes.units.data
									.filter((unit) => !unit.attributes.isDiagram)
									.map((unit) => `Блок_${unit.attributes.name}`),
								...item.attributes.units.data
									.filter((unit) => unit.attributes.isDiagram)
									.map((unit) => `Схема_${unit.attributes.name}`),
							]
								.filter((unit) => unit)
								.join(),
					signalType: item.attributes?.signalType?.data?.attributes?.title,
					protocolName: item.attributes?.protocol?.data?.attributes?.title,
					type: "signal",
					protocolTypeId:
						item.attributes?.protocol?.data?.attributes?.protocolType?.data?.id,
					// Для isDiagram добавить поле kind
					kind: isDiagram ? ELEMENT_TYPES.INDICATOR_VALUE : undefined,
					kindLabel: isDiagram
						? getKindLabel(ELEMENT_TYPES.INDICATOR_VALUE)
						: undefined,
					quality: qualityMap.get(item.id) ?? null,
					dataProvision: { key: `${item.id}_signal`, type: "signal" },
				}));
				return teleSignalsData;
			}
		} catch (error) {
			console.error(error);
		}
	};

	const fetchUnit = async () => {
		try {
			let response;

			if (isDiagram) {
				// Для диаграмм используем junction таблицы
				response = await fetchWithAuth(
					`${API}/units/${unitId}?populate[0]=unitTeleMeasurements.teleMeasurement&populate[1]=unitTeleSignals.teleSignal`,
				);

				const data = await response.json();
				setIdModbus(data.data.attributes.ID_Modbus);
				setName(data.data.attributes.name);
				setFuxaView(data.data.attributes.fuxaView);

				const unitTeleMeasurements =
					data.data.attributes?.unitTeleMeasurements?.data ?? [];
				const unitTeleSignals =
					data.data.attributes?.unitTeleSignals?.data ?? [];

				const teleMeasurementsFromUnit = unitTeleMeasurements.map((utm) => {
					const baseTM = dataTable.find(
						({ id, type }) =>
							id === utm.attributes.teleMeasurement.data.id &&
							type === "measurement",
					);
					return {
						...baseTM,
						unitTeleMeasurementId: utm.id,
						kind: utm.attributes.kind || ELEMENT_TYPES.INDICATOR_VALUE,
						kindLabel: getKindLabel(
							utm.attributes.kind || ELEMENT_TYPES.INDICATOR_VALUE,
						),
					};
				});

				const teleSignalsFromUnit = unitTeleSignals.map((uts) => {
					const baseTS = dataTable.find(
						({ id, type }) =>
							id === uts.attributes.teleSignal.data.id && type === "signal",
					);
					return {
						...baseTS,
						unitTeleSignalId: uts.id,
						kind: uts.attributes.kind || ELEMENT_TYPES.INDICATOR_VALUE,
						kindLabel: getKindLabel(
							uts.attributes.kind || ELEMENT_TYPES.INDICATOR_VALUE,
						),
					};
				});

				setDataCandidateTable([
					...teleMeasurementsFromUnit,
					...teleSignalsFromUnit,
				]);
			} else {
				// Для обычных блоков используем старый подход
				response = await fetchWithAuth(
					`${API}/units/${unitId}?populate=teleSignals,teleMeasurements,temperatureTm,pbrTm`,
				);

				const data = await response.json();
				const teleMeasurementKeys =
					data.data.attributes?.teleMeasurements?.data.map(
						(item) => `${item.id}_measurement`,
					) ?? [];
				const teleSignalKeys =
					data.data.attributes?.teleSignals?.data.map(
						(item) => `${item.id}_signal`,
					) ?? [];

				setIdModbus(data.data.attributes.ID_Modbus);
				setName(data.data.attributes.name);
				const teleMeasurements = dataTable.filter(({ key }) =>
					teleMeasurementKeys.includes(key),
				);
				const teleSignals = dataTable.filter(({ key }) =>
					teleSignalKeys.includes(key),
				);

				if (
					data.data.attributes.temperatureTm?.data?.id &&
					teleMeasurements.length > 0
				) {
					teleMeasurements.find(
						({ id }) => id === data.data.attributes.temperatureTm.data.id,
					).dataProvision.value = TEMPARATURE;
				}

				if (
					data.data.attributes.pbrTm?.data?.id &&
					teleMeasurements.length > 0
				) {
					teleMeasurements.find(
						({ id }) => id === data.data.attributes.pbrTm.data.id,
					).dataProvision.value = PBR;
				}

				setDataCandidateTable([...teleMeasurements, ...teleSignals]);
			}
		} catch (error) {
			console.error(error);
		}
	};

	useEffect(() => {
		if (unitId) {
			setIsEditing(true);
		} else {
			setIsEditing(false);
		}
		fetchTele();
		fetchProtocolTypes();
	}, [unitId]);

	useEffect(() => {
		if (unitId && dataTable.length > 0) {
			fetchUnit();
		}
	}, [dataTable]);

	useEffect(() => {
		if (!isDiagram) return;

		(async () => {
			try {
				const response = await fetchWithAuth(`${API}/fuxa/views`);
				if (!response.ok) {
					throw new Error("Не удалось получить список Views из FUXA");
				}
				const json = await response.json();
				setFuxaViews(json.data ?? []);
			} catch (e) {
				setFuxaViewsError(e.message);
			}
		})();
	}, [isDiagram]);

	const handleRemove = (teleKey) => {
		setDataCandidateTable((prev) => prev.filter(({ key }) => key !== teleKey));
	};

	const handleAdd = (teleKey) => {
		const item = dataTable.find(({ key }) => key === teleKey);
		const newItem = { ...item };
		newItem.dataProvision = item.dataProvision
			? { ...item.dataProvision }
			: undefined;
		if (newItem.dataProvision) {
			newItem.dataProvision.value = null;
		}
		if (isDiagram) {
			newItem.kind = ELEMENT_TYPES.INDICATOR_VALUE;
			newItem.kindLabel = getKindLabel(ELEMENT_TYPES.INDICATOR_VALUE);
		}
		setDataCandidateTable((prev) => [...prev, newItem]);
	};

	const handleSave = async () => {
		try {
			if (isDiagram) {
				// Для диаграмм: сохранить через junction таблицы
				await handleSaveDiagram();
			} else {
				// Для обычных блоков: использовать старый подход
				await handleSaveRegularUnit();
			}
		} catch (error) {
			console.error(error);
		}
	};

	const handleSaveDiagram = async () => {
		try {
			const unitTeleMeasurementsData = dataCandidateTable
				.filter(({ type }) => type === "measurement")
				.map((item) => ({
					unitTeleMeasurementId: item.unitTeleMeasurementId,
					teleMeasurementId: item.id,
					kind: item.kind || ELEMENT_TYPES.INDICATOR_VALUE,
				}));

			const unitTeleSignalsData = dataCandidateTable
				.filter(({ type }) => type === "signal")
				.map((item) => ({
					unitTeleSignalId: item.unitTeleSignalId,
					teleSIgnalId: item.id,
					kind: item.kind || ELEMENT_TYPES.INDICATOR_VALUE,
				}));

			const body = {
				data: {
					name: name,
					ID_Modbus: idModbus,
					isDiagram: true,
					fuxaView: fuxaView,
				},
			};

			if (isEditing) {
				const requestOptions = {
					method: "PUT",
					headers: { "Content-Type": "application/json" },
					body: JSON.stringify(body),
				};

				const response = await fetchWithAuth(
					`${API}/units/${unitId}`,
					requestOptions,
				);

				if (response.ok) {
					await saveUnitTeleMeasurements(unitId, unitTeleMeasurementsData);
					await saveUnitTeleSignals(unitId, unitTeleSignalsData);

					setRedirectId(unitId);
					await updateMenu();
					await delay(500);
					redirect();
				}
			} else {
				const requestOptions = {
					method: "POST",
					headers: { "Content-Type": "application/json" },
					body: JSON.stringify(body),
				};

				const response = await fetchWithAuth(`${API}/units`, requestOptions);

				if (response.ok) {
					const result = await response.json();
					const newUnitId = result.data.id;

					await saveUnitTeleMeasurements(newUnitId, unitTeleMeasurementsData);
					await saveUnitTeleSignals(newUnitId, unitTeleSignalsData);

					setRedirectId(newUnitId);
					await updateMenu();
					await delay(500);
					redirect();
				}
			}
		} catch (error) {
			console.error("Ошибка при сохранении диаграммы:", error);
		}
	};

	const handleSaveRegularUnit = async () => {
		try {
			const body = {
				data: {
					name: name,
					ID_Modbus: idModbus,
					teleMeasurements:
						dataCandidateTable
							.filter(({ type }) => type === "measurement")
							.map((item) => item.id) ?? [],
					teleSignals:
						dataCandidateTable
							.filter(({ type }) => type === "signal")
							.map((item) => item.id) ?? [],
					temperatureTm: dataCandidateTable.find(
						({ dataProvision }) => dataProvision?.value === TEMPARATURE,
					)?.id,
					pbrTm: dataCandidateTable.find(
						({ dataProvision }) => dataProvision?.value === PBR,
					)?.id,
					isDiagram: false,
				},
			};

			if (isEditing) {
				const requestOptions = {
					method: "PUT",
					headers: { "Content-Type": "application/json" },
					body: JSON.stringify(body),
				};

				const response = await fetchWithAuth(
					`${API}/units/${unitId}`,
					requestOptions,
				);
				setRedirectId(unitId);
				if (response.ok) {
					await updateMenu();
					await delay(500);
					redirect();
				}
			} else {
				const requestOptions = {
					method: "POST",
					headers: { "Content-Type": "application/json" },
					body: JSON.stringify(body),
				};

				const response = await fetchWithAuth(`${API}/units`, requestOptions);

				if (response.ok) {
					const result = await response.json();
					setRedirectId(result.data.id);
					await updateMenu();
					await delay(500);
					redirect();
				}
			}
		} catch (error) {
			console.error("Ошибка при сохранении блока:", error);
		}
	};

	const saveUnitTeleMeasurements = async (unitId, measurements) => {
		try {
			for (const measurement of measurements) {
				if (measurement.unitTeleMeasurementId) {
					const updateData = {
						data: {
							kind: measurement.kind,
						},
					};
					const requestOptions = {
						method: "PUT",
						headers: { "Content-Type": "application/json" },
						body: JSON.stringify(updateData),
					};

					await fetchWithAuth(
						`${API}/unit-tele-measurements/${measurement.unitTeleMeasurementId}`,
						requestOptions,
					);
				} else {
					const createData = {
						data: {
							unit: unitId,
							teleMeasurement: measurement.teleMeasurementId,
							kind: measurement.kind,
						},
					};
					const requestOptions = {
						method: "POST",
						headers: { "Content-Type": "application/json" },
						body: JSON.stringify(createData),
					};

					await fetchWithAuth(`${API}/unit-tele-measurements`, requestOptions);
				}
			}
		} catch (error) {
			console.error("Ошибка при сохранении unit tele-measurements:", error);
		}
	};

	const saveUnitTeleSignals = async (unitId, signals) => {
		try {
			for (const signal of signals) {
				if (signal.unitTeleSignalId) {
					const updateData = {
						data: {
							kind: signal.kind,
						},
					};
					const requestOptions = {
						method: "PUT",
						headers: { "Content-Type": "application/json" },
						body: JSON.stringify(updateData),
					};

					await fetchWithAuth(
						`${API}/unit-tele-signals/${signal.unitTeleSignalId}`,
						requestOptions,
					);
				} else {
					const createData = {
						data: {
							unit: unitId,
							teleSignal: signal.teleSIgnalId,
							kind: signal.kind,
						},
					};
					const requestOptions = {
						method: "POST",
						headers: { "Content-Type": "application/json" },
						body: JSON.stringify(createData),
					};

					await fetchWithAuth(`${API}/unit-tele-signals`, requestOptions);
				}
			}
		} catch (error) {
			console.error("Ошибка при сохранении unit tele-signals:", error);
		}
	};

	const delay = (milliseconds) =>
		new Promise((resolve) => setTimeout(resolve, milliseconds));

	const redirect = () => {
		if (wrapperRef.current) {
			wrapperRef.current.querySelector("a").click();
		}
	};

	const Step2 = () => {
		const handleSetOnlyTeleMeasurement = ({ target: { checked } }) => {
			setFormData((prevFormData) => ({
				...prevFormData,
				onlyTeleMeasurement: checked,
			}));
		};

		const handleSetOnlyTeleSignal = ({ target: { checked } }) => {
			setFormData((prevFormData) => ({
				...prevFormData,
				onlyTeleSignal: checked,
			}));
		};

		const handleSetIsEmptyUnit = ({ target: { checked } }) => {
			setFormData((prevFormData) => ({
				...prevFormData,
				isEmptyUnit: checked,
			}));
		};

		const handleChange = (event) => {
			const { name, value } = event.target;
			setFormData((prevFormData) => ({ ...prevFormData, [name]: value }));
		};

		let localData = dataTable;

		if (formData.onlyTeleMeasurement) {
			localData = localData.filter(({ type }) => type === "measurement");
		}

		if (formData.onlyTeleSignal) {
			localData = localData.filter(({ type }) => type === "signal");
		}

		if (formData.isEmptyUnit) {
			localData = localData.filter(({ unitsName }) => unitsName === "");
		}

		if (formData.protocolType) {
			localData = localData.filter(
				({ protocolTypeId }) =>
					protocolTypeId === parseInt(formData.protocolType),
			);
		}

		if (dataCandidateTable && dataCandidateTable.length > 0) {
			localData = localData.filter(
				({ key }) =>
					dataCandidateTable.findIndex((item) => item.key === key) === -1,
			);
		}

		return (
			<>
				<Row>
					<Col md={4}> </Col>
					<Col style={{ marginLeft: 20 }} md={3}>
						{" "}
						<h4> Добавление телеизмерений и телесигналов </h4>{" "}
					</Col>{" "}
					<Col md={5}></Col>{" "}
				</Row>
				<Row>
					<Col md={5}> </Col>
					<Col style={{ marginLeft: 20 }} md={2}>
						{" "}
						{isDiagram ? "Добавлены к схеме" : "Добавлены к блоку"}{" "}
					</Col>{" "}
					<Col md={5}></Col>{" "}
				</Row>
				<Row>
					<Col md={2}> </Col>
					<Col md={8}>
						<SimpleTable
							hover
							condensed
							columns={candidateColumns.concat([
								{
									title: "",
									data: "key",
									render: (key) =>
										key && (
											<>
												<Button
													icon="fa-trash"
													onClick={() => handleRemove(key)}
													className="clickable"
												/>{" "}
											</>
										),
								},
							])}
							data={dataCandidateTable}
						/>
					</Col>
					<Col md={2}> </Col>
				</Row>
				<Row>
					<Col md={2}> </Col>
					<Col md={8}>
						{dataCandidateTable.length > 0 &&
							!isDiagram &&
							Object.keys(errors).length > 0 && (
								<div className="warning-summary">
									{errors.temperature && (
										<p>
											<FontAwesomeIcon
												color={"#fab005"}
												icon={["fas", "exclamation-triangle"]}
											/>
											{errors.temperature}
										</p>
									)}
									{errors.PBR && (
										<p>
											{" "}
											<FontAwesomeIcon
												color={"#fab005"}
												icon={["fas", "exclamation-triangle"]}
											/>{" "}
											{errors.PBR}
										</p>
									)}
								</div>
							)}
					</Col>
					<Col md={2}> </Col>
				</Row>
				<Row>
					<Col md={2}> </Col>
					<Col sm={8}>
						<Box type="default" solid>
							<Row>
								<Col md={2}>
									<div className="checkbox">
										<label>
											<input
												checked={formData.onlyTeleSignal}
												onChange={handleSetOnlyTeleSignal}
												type="checkbox"
											/>{" "}
											телесигнал
										</label>
									</div>
								</Col>
								<Col md={3}>
									<div className="checkbox">
										<label>
											<input
												checked={formData.onlyTeleMeasurement}
												onChange={handleSetOnlyTeleMeasurement}
												type="checkbox"
											/>{" "}
											телеизмерение
										</label>
									</div>
								</Col>

								{!isDiagram && (
									<Col md={3}>
										<div className="checkbox">
											<label>
												<input
													checked={formData.isEmptyUnit}
													onChange={handleSetIsEmptyUnit}
													type="checkbox"
												/>{" "}
												Не привязан
											</label>
										</div>
									</Col>
								)}

								<Col md={isDiagram ? 6 : 4}>
									<Select2
										placeholder="Стандарт протокола"
										allowClear
										size="sm"
										sm={12}
										labelSm={0}
										name="protocolType"
										options={protocolTypes}
										value={formData.protocolType}
										onChange={handleChange}
									/>
								</Col>
							</Row>
						</Box>
					</Col>
					<Col md={2}> </Col>
				</Row>
				<Row>
					<Col md={5}> </Col>
					<Col style={{ marginLeft: 20 }} md={2}>
						{" "}
						Доступные ТИ и ТС{" "}
					</Col>{" "}
					<Col md={5}></Col>{" "}
				</Row>
				<Row>
					<Col md={2}> </Col>
					<Col md={8}>
						<SimpleTable
							hover
							condensed
							columns={columns.concat([
								{
									title: "",
									data: "key",
									render: (key) =>
										key && (
											<>
												<Button
													icon="fa-plus"
													onClick={() => handleAdd(key)}
													className="clickable"
												/>{" "}
											</>
										),
								},
							])}
							data={localData}
						/>
					</Col>
					<Col md={2}> </Col>
				</Row>
			</>
		);
	};

	return (
		<Content
			title={`${isEditing ? "Редактирование" : "Добавление"} ${isDiagram ? "схемы" : "блока"}`}
		>
			<Box type="primary" title="">
				<div>
					{currentStep === 1 && (
						<>
							<Row>
								<Col md={4}></Col>
								<Col md={3}>
									<Text
										labelSm={4}
										sm={3}
										onChange={handleChangeIdModbus}
										name="idModbus"
										value={idModbus}
										inputType="number"
										placeholder=""
										label="ID Modes Terminal"
										labelPosition="above"
									/>
								</Col>
								<Col md={5}></Col>
							</Row>
							<Row>
								<Col md={4}></Col>
								<Col md={3}>
									<Text
										labelSm={4}
										sm={3}
										onChange={handleChangeName}
										name="name"
										value={name}
										placeholder=""
										label={isDiagram ? "Название схемы" : "Название блока"}
										labelPosition="above"
									/>
								</Col>
								<Col md={5}></Col>
							</Row>
							{isDiagram && (
								<Row>
									<Col md={4}></Col>
									<Col md={3}>
										<label
											style={{ display: "block", marginBottom: 4 }}
										>
											View в FUXA
										</label>
										{fuxaViewsError ? (
											<>
												<div
													className="alert alert-warning"
													style={{ padding: 8, marginBottom: 4 }}
												>
													Не удалось загрузить список Views ({fuxaViewsError}).
													Введите name вручную.
												</div>
												<input
													type="text"
													className="form-control"
													value={fuxaView || ""}
													onChange={handleChangeFuxaView}
													placeholder="например, main"
												/>
											</>
										) : (
											<select
												className="form-control"
												value={fuxaView || ""}
												onChange={handleChangeFuxaView}
											>
												<option value="">Не выбрано</option>
												{fuxaViews.map((view) => (
													<option key={view.id} value={view.name}>
														{view.name}
													</option>
												))}
											</select>
										)}
									</Col>
									<Col md={5}></Col>
								</Row>
							)}
						</>
					)}
					{currentStep === 2 && <Step2 formData={formData} />}

					<div style={{ marginTop: "20px" }}>
						{currentStep < 2 && (
							<Row>
								<Col md={5}></Col>
								<Col style={{ marginLeft: 20 }} md={2}>
									{" "}
									<Button
										size="md"
										onClick={handleNext}
										type="primary"
										text="Далее"
									/>
								</Col>{" "}
								<Col md={5}></Col>{" "}
							</Row>
						)}

						{currentStep === 2 && (
							<Row>
								<Col md={3}> </Col>
								<Col md={6}>
									<Button
										size="md"
										onClick={handleBack}
										type="primary"
										text="Назад"
										pullLeft
									/>
									<Button
										size="md"
										disabled={
											(!isDiagram && Object.keys(errors).length > 0) ||
											dataCandidateTable.length === 0
										}
										onClick={handleSave}
										type="primary"
										text="Сохранить"
										pullRight
									/>
								</Col>
								<Col md={3}> </Col>
							</Row>
						)}
					</div>
					{/* Проблема с либой adminlte-2-react она используется react router v5 */}
					<div style={{ display: "none" }} ref={wrapperRef}>
						{" "}
						<Button
							to={redirectId && isDiagram ? "/fuxa" : `/main/${redirectId}/`}
						></Button>{" "}
					</div>
				</div>
			</Box>
		</Content>
	);
};

export default UnitForm;
